// Consistent status colors for all merchant pages
export const STATUS_COLORS = {
  PROCESSING: {
    bgcolor: '#F0F2FF', // lighter purple background
    color: '#6318C6', // main purple color
    borderColor: '#6318C6',
    iconColor: '#6318C6'
  },
  COMPLETED: {
    bgcolor: '#F0FDF4', // lighter green
    color: '#16a34a', // green
    borderColor: '#16a34a',
    iconColor: '#16a34a'
  },
  FAILED: {
    bgcolor: '#FEF7F7', // lighter red
    color: '#dc2626', // red
    borderColor: '#dc2626',
    iconColor: '#dc2626'
  },
  CANCELLED: {
    bgcolor: '#FFFBEB', // lighter yellow/amber
    color: '#d97706', // amber
    borderColor: '#d97706',
    iconColor: '#d97706'
  },
  PENDING: {
    bgcolor: '#F0F2FF', // same as PROCESSING - lighter purple background
    color: '#6318C6', // same as PROCESSING - main purple color
    borderColor: '#6318C6',
    iconColor: '#6318C6'
  }
};

// Helper function to get status colors
export const getStatusColors = (statusName) => {
  const status = statusName?.toUpperCase();
  return STATUS_COLORS[status] || STATUS_COLORS.PROCESSING;
};

// Helper function for status chips
export const getStatusChipStyles = (statusName) => {
  const colors = getStatusColors(statusName);
  return {
    bgcolor: colors.bgcolor,
    color: colors.color,
    fontWeight: 700,
    borderRadius: 2,
    fontSize: 11,
    height: 20,
    letterSpacing: 0.5,
    '& .MuiChip-icon': {
      color: colors.iconColor,
      fontSize: 14,
      marginLeft: 0.5,
      marginRight: -0.5,
    }
  };
};
